import { Button, CoinBadge, Switch } from 'components/common';
import useBottomSheet from 'hooks/common/useBottomSheet';
import usePictureUpload from 'hooks/chat/usePictureUpload';
import { useEffect } from 'react';

export type PictureUploadData = {
  uid: string;
  no: any;
  blob: string;
  width: number;
  height: number;
};

const LOADING_ID = 'PictureUploadLoading';

const PictureUpload: React.FC = () => {
  const { sheets, close } = useBottomSheet();
  const sheet = sheets.PictureUpload;
  const data = sheet.data as PictureUploadData;

  const { isLoading, boomSwitchOn, boomPrice, handleUpload, handleBoomSwitchChange } = usePictureUpload(close, data);

  useEffect(() => {
    if (isLoading) BUtil.showLoading(LOADING_ID, 20000, '#BBDEFB');
    else BUtil.hideLoading(LOADING_ID);
    return () => {
      BUtil.hideLoading(LOADING_ID);
    };
  }, [isLoading]);

  return (
    <div className="flex h-full w-full flex-col items-center gap-[var(--spacing-lg)]">
      <img src={data.blob} className="rounded-lg bg-gray-500" style={{ maxHeight: 'calc(80vh - 240px)', maxWidth: '100%' }} alt="" />
      <div className="flex flex-col gap-[var(--spacing-sm)]">
        <div className="flex items-center gap-[var(--spacing-lg)]">
          <div className="flex min-h-[36px] flex-1 items-center gap-[var(--spacing-xs)]">
            <div className="typography-title-md">{brsc.boom_use}</div>
            {boomSwitchOn && <CoinBadge value={boomPrice} />}
          </div>
          <Switch isOn={boomSwitchOn} onChange={handleBoomSwitchChange} />
        </div>
        <div className="typography-body-sm text-dialog-txt-secondary">{brsc.boom_upload_guide}</div>
      </div>
      <div className="flex w-full gap-[var(--spacing-sm)]">
        <Button
          onClick={() => close('PictureUpload')}
          style={{ text: brsc.pc_modal_back, fontColor: 'btn-txt-normal', background: 'var(--bcs-semantic-btn-bg-normal)' }}
          className="flex-1"
        />
        <Button onClick={handleUpload} style={{ text: brsc.send_btn, fontColor: 'btn-txt-secondary', background: 'var(--bcs-semantic-btn-bg-secondary)' }} className="flex-1" />
      </div>
    </div>
  );
};

export default PictureUpload;
